module.exports = __webpack_public_path__ + "img/AT0000001060464.022ea4cf.png";